import {formEncodedApi} from 'nutshell-core/api';
import {mapEntityToDisplayOption} from 'nutshell-core/utils';
import type {Entity, DisplayOptionEntity} from 'nutshell-core/utils';

import type {AccountInput} from 'shells/peep-cards/account-card/types';
import {ROWS} from 'shells/peep-cards/consts';

export function getPotentialAccounts(input: {
    accountInput: AccountInput;
    alreadyAddedAccounts: string[] | null | undefined;
}): Promise<any> {
    const {accountInput, alreadyAddedAccounts} = input;

    const data = {
        rows: ROWS,
        fields: [
            {
                name: 'name',
                value: accountInput.name,
            },
            {
                name: 'description',
                value: accountInput.description,
            },
            {
                name: 'regions',
                value: accountInput.address,
            },
        ],
    } as const;

    return (
        formEncodedApi
            .post('/solr/find-potential-accounts.json', {
                ...data,
            })
            // @ts-expect-error
            .then((response) => response.json())
            .then((response: {results: Entity[]}) => {
                const results: Entity[] = response.results ? response.results : [];

                return results
                    .map<DisplayOptionEntity>((entity: Entity) => {
                        return mapEntityToDisplayOption(entity);
                    })
                    .filter((entity: DisplayOptionEntity) => {
                        return alreadyAddedAccounts && !alreadyAddedAccounts.includes(entity.id);
                    });
            })
    );
}
